import { yieldExecution } from '#common/util';
import { createAesCrypto, createBase64RsaCrypto, createRsaCrypto, RSA_DEFAULT_SCHEME } from '#crypto/node-forge';
import { createBase64RsaCryptoAsync, createRsaCryptoAsync } from '#crypto/web-crypto';
export function registerSharedWasmHandlers(mod) {
    setRsaEncryptDecryptHandlers(mod);
    registerSyncWasmHandlers(mod);
}
// The AES handlers are synchronous, so they are also safe to install on the sync module -- which
// the synchronous wrappers (key-value helpers, tuple, utils) run on.
export function registerSyncWasmHandlers(mod) {
    const aesCrypto = createAesCrypto();
    const cryptoGen = createAesCrypto();
    setAesKeyGeneratorHandler(mod, cryptoGen);
    setAesHmacGeneratorHandler(mod, aesCrypto);
    setAesEncryptDecryptHandlers(mod, aesCrypto);
}
function setRsaEncryptDecryptHandlers(mod) {
    mod['decryptRsaHandler'] = async (cryptoText, privateKey) => {
        const principalCrypto = createBase64RsaCrypto(createRsaCrypto({ scheme: RSA_DEFAULT_SCHEME, serializedPrivateKey: privateKey }));
        const result = principalCrypto.decryptLong(cryptoText);
        await yieldExecution();
        return { result };
    };
    mod['encryptRsaHandler'] = (cryptoText, publicKey) => {
        const principalCrypto = createBase64RsaCrypto(createRsaCrypto({ scheme: RSA_DEFAULT_SCHEME, serializedPublicKey: publicKey }));
        const encrypted = principalCrypto.encryptLong(cryptoText);
        return { result: encrypted };
    };
    setBatchDecryptRsaHandler(mod);
}
function setBatchDecryptRsaHandler(mod) {
    mod['batchDecryptRsaHandler'] = async (items) => {
        const uniqueKeys = [...new Set(items.map((item) => item.key))];
        const cryptoInstances = await Promise.all(uniqueKeys.map(async (key) => createBase64RsaCryptoAsync(await createRsaCryptoAsync({ serializedPrivateKey: key }))));
        const keyToCrypto = new Map(uniqueKeys.map((key, i) => [key, cryptoInstances[i]]));
        return Promise.all(items.map(async (item) => ({ result: await keyToCrypto.get(item.key).decryptLong(item.cryptoText) })));
    };
}
function setAesKeyGeneratorHandler(mod, cryptoGen) {
    mod['generateAesCryptoKeyHandler'] = () => {
        const result = cryptoGen.generateKey();
        return { result };
    };
}
function setAesHmacGeneratorHandler(mod, aesCrypto) {
    mod['hmacHandler'] = (text, key) => {
        const result = aesCrypto.getHmac(text, key);
        return { result };
    };
}
function setAesEncryptDecryptHandlers(mod, aesCrypto) {
    mod['decryptAesHandler'] = (cryptoText, key, iv) => {
        const encryptedValue = {
            value: cryptoText,
            iv,
        };
        const result = aesCrypto.decrypt(encryptedValue, key);
        return { result };
    };
    mod['encryptAesHandler'] = (text, key, iv) => {
        const result = aesCrypto.encrypt(text, key, iv);
        return { result: result };
    };
}
